import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getDialogById } from "store/bailiff/task/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str

const COLOR_STATUS = {
  pass: "",
  warn: "border-[1px] border-orange-500 text-orange-500",
  deny: "border-[1px] border-red-500 text-red-500",
};

const DialogContent = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const dialog = data?.dialog;
  // -------------------------- STATE ---------------------------
  const [detail, setDetail] = useState(null);
  const sentences = detail?.sentences || 0;
  const rate = detail?.rate || "pass";
  const firstSentences = sentences?.[0];
  const reason = rate === "pass" ? "" : `Lý do: ${detail?.reason}`;
  const firstContent = firstSentences?.fix || firstSentences?.text || "";

  const classDiv = COLOR_STATUS[rate];
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (dialog) {
      dispatch(
        getDialogById({ id: dialog }, (res) => {
          if (res) {
            setDetail(res);
          }
        }),
      );
    }
  }, [dialog, dispatch]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderOther = () => {
    if (rate !== "pass") {
      return <div className={`${classDiv} p-[16px]`}>{reason}</div>;
    }
  };
  // -------------------------- MAIN ----------------------------
  if (!detail)
    return (
      <div className="flex min-h-[100px] flex-[0.8] items-center justify-center gap-2 rounded-md border-[1px] border-gray-200">
        <Spin size="small" indicator={<LoadingOutlined spin />} />
        <div className="text-[12px] text-gray-700">Đang tải đoạn hội thoại</div>
      </div>
    );
  return (
    <div className="flex-[0.8]">
      <div>
        <b>SL</b>: {sentences?.length} đoạn
      </div>
      <div>
        <Typography.Paragraph ellipsis={{ rows: 4 }}>
          <b>Nội dung đoạn đầu</b>: {firstContent}
        </Typography.Paragraph>
      </div>
      {renderOther()}
    </div>
  );
};
export default DialogContent;
